import { StandardEvents } from '@shopify/events';
import { ThemeEvents } from '@theme/events';

class BislboxPreorderConsent extends HTMLElement {
  connectedCallback() {
    this.addEventListener('change', this.handleChange);
    document.addEventListener(StandardEvents.cartLinesUpdate, this.handleCartUpdate);
    document.addEventListener(ThemeEvents.quantitySelectorUpdate, this.handleQuantityUpdate);
    this.sync();
  }

  disconnectedCallback() {
    this.removeEventListener('change', this.handleChange);
    document.removeEventListener(StandardEvents.cartLinesUpdate, this.handleCartUpdate);
    document.removeEventListener(ThemeEvents.quantitySelectorUpdate, this.handleQuantityUpdate);
  }

  /** @param {Event} event */
  handleChange = (event) => {
    if (!(event.target instanceof HTMLInputElement) || !event.target.matches('.bislbox-preorder-consent__checkbox')) {
      return;
    }

    this.sync();
  };

  /** @param {Event} event */
  handleQuantityUpdate = (event) => {
    const cartItems = this.closest('cart-items-component');
    if (!(event.target instanceof Node) || !cartItems?.contains(event.target)) return;

    // Cart quantity changes are debounced before cartLinesUpdate. Revoke consent
    // immediately so checkout cannot remain enabled during that debounce window.
    this.resetConsent();
  };

  /** @param {import('@shopify/events').CartLinesUpdateEvent} event */
  handleCartUpdate = (event) => {
    // An acknowledgement applies only to the cart state the customer reviewed.
    // Revoke it while the request is pending, then again after Horizon morphs the
    // returned section because the morph can preserve a checkbox's live state.
    this.resetConsent();
    event.promise
      ?.then(() => {
        requestAnimationFrame(() => {
          if (this.isConnected) this.resetConsent();
        });
      })
      .catch((error) => {
        if (error?.name !== 'AbortError') console.warn('[preorder-consent] Cart update rejected:', error);
      });
  };

  resetConsent() {
    const checkbox = this.querySelector('.bislbox-preorder-consent__checkbox');
    if (checkbox instanceof HTMLInputElement) checkbox.checked = false;
    this.sync();
  }

  sync() {
    const checkbox = this.querySelector('.bislbox-preorder-consent__checkbox');
    const scope = this.closest('.cart-summary__inner, .cart-drawer__summary') || this.parentElement;
    const checkoutButton = scope?.querySelector('#checkout');

    if (!(checkbox instanceof HTMLInputElement) || !(checkoutButton instanceof HTMLButtonElement)) return;

    const disabled = !checkbox.checked;
    if (checkoutButton.disabled !== disabled) checkoutButton.disabled = disabled;

    const ariaDisabled = String(disabled);
    if (checkoutButton.getAttribute('aria-disabled') !== ariaDisabled) {
      checkoutButton.setAttribute('aria-disabled', ariaDisabled);
    }
  }
}

if (!customElements.get('bislbox-preorder-consent')) {
  customElements.define('bislbox-preorder-consent', BislboxPreorderConsent);
}
